
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/paintings",
      function () {
        return require("private-next-pages/works/paintings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/paintings"])
      });
    }
  